import { render, staticRenderFns } from "./VoiceSettings.vue?vue&type=template&id=92f54600&scoped=true"
import script from "./VoiceSettings.vue?vue&type=script&lang=js"
export * from "./VoiceSettings.vue?vue&type=script&lang=js"
import style0 from "./VoiceSettings.vue?vue&type=style&index=0&id=92f54600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f54600",
  null
  
)

export default component.exports